<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Zone erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.zones.store'))">
                <form-fields :form="form" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
        ],
        data() {
            return {
                form: this.$inertia.form({
                    uid: null,
                    name: null,
                    description: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>